import { Component, input } from '@angular/core';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

@Component({
  selector: 're-app-brand-logo',
  templateUrl: './app-brand-logo.component.html',
  styleUrl: './app-brand-logo.component.scss',
  imports: [...TRANSLATE_IMPORTS],
  host: {
    class: 're-app-brand-logo',
    '[class.re-app-brand-logo--full]': "variant() === 'full'",
    '[class.re-app-brand-logo--icon]': "variant() === 'icon'",
    '[class.re-app-brand-logo--compact]': "size() === 'compact'",
  },
})
export class AppBrandLogoComponent {
  variant = input<'full' | 'icon'>('full');
  size = input<'default' | 'compact'>('default');
}
